import { localeReducer } from './locale';
import { screenReducer } from './screen';
import { userReducer } from './user';
import { routeReducer } from './route';
import type {
  ActiveFeatureConfigAction,
  GlobalContextAction,
  GlobalContextReducerState,
  LocaleAction,
  RouterAction,
  ScreenAction,
  UserAction
} from './types';
import { activeFeatureConfigReducer } from './activeFeatureConfig';
import { Portal } from '@dfg/brahma-types';

export const rootReducer = (
  {
    screen,
    locale,
    user,
    route,
    activeFeatureConfig
  }: GlobalContextReducerState,
  action: GlobalContextAction
): GlobalContextReducerState => ({
  screen: screenReducer(screen, action as ScreenAction),
  locale: localeReducer(locale, action as LocaleAction),
  user: userReducer(user, action as UserAction),
  route: routeReducer(route, action as RouterAction),
  activeFeatureConfig: activeFeatureConfigReducer(
    activeFeatureConfig,
    action as ActiveFeatureConfigAction
  ),
  portal: Portal.CLIENT
});
